export const ANALYTICS_SOURCE = 'byline-connections';
export const MENU_ITEM_ACTION_SUBJECT_ID = 'connectionsBylineMenuItem';
export const SCROLL_RESULT_ACTION_SUBJECT_ID = 'connectionsBylineMenuItemScroll';

export type SmartLinkScrollResult = 'success' | 'not_found' | 'scroll_error';
